import React, { useEffect, useRef } from 'react';
import { leadershipData } from '../utils/constants';
const Leadership = ({
  language = 'en'
}) => {
  const sectionRef = useRef(null);
  // Add Student Government entry
  const studentGovernment = {
    organization: 'Student Government',
    organizationVi: 'Chính Quyền Sinh Viên',
    role: 'Class President',
    roleVi: 'Chủ Tịch Lớp',
    description: 'Raised over $55,000 for Class 2024 through corporate sponsorships and events. Organized proms, spirit rallies, and football games while serving as communication link between administration and students.',
    descriptionVi: 'Gây quỹ hơn $55,000 cho Lớp 2024 thông qua tài trợ doanh nghiệp và sự kiện. Tổ chức dạ hội, cổ vũ tinh thần, và trò chơi bóng đá trong khi làm cầu nối giữa ban quản lý và sinh viên.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/q3bxQpZWfEe17vEHQUy9FD/SPS_logo.png',
    dates: 'August 2021 – June 2023',
    datesVi: 'Tháng 8/2021 – Tháng 6/2023',
    location: 'Shrewsbury, MA',
    locationVi: 'Shrewsbury, MA',
    details: ['Organized and hosted class major events such as proms, spirit rally, football games and other fun activities', 'Raised over 55,000 USD for Class 2024 through corporate sponsorships, student events, class dues', 'Served as the communication between school administration and the student body regarding school-related events', 'Organized weekly Class Officers meetings to ensure the class maintained healthy finances while maximizing attendance through subsidized event affordability programs'],
    detailsVi: ['Tổ chức và chủ trì các sự kiện lớn của lớp như dạ hội, cổ vũ tinh thần, trò chơi bóng đá và các hoạt động vui chơi khác', 'Gây quỹ hơn 55.000 USD cho Lớp 2024 thông qua tài trợ doanh nghiệp, sự kiện sinh viên, lệ phí lớp', 'Làm cầu nối giữa ban quản lý trường và sinh viên về các sự kiện liên quan đến trường học', 'Tổ chức các cuộc họp Cán bộ Lớp hàng tuần để đảm bảo lớp duy trì tài chính lành mạnh trong khi tối đa hóa số lượng tham dự thông qua các chương trình trợ giá sự kiện']
  };
  const translations = {
    en: {
      leadership: 'Leadership',
      experience: 'Experience',
      studentGovernment: 'Student Government',
      classPresident: 'Class President',
      class2024: 'Class 2024',
      nonprofitLeadership: 'Nonprofit Leadership',
      universityLeadership: 'University Leadership'
    },
    vi: {
      leadership: 'Kinh Nghiệm',
      experience: 'Lãnh Đạo',
      studentGovernment: 'Chính Quyền Sinh Viên',
      classPresident: 'Chủ Tịch Lớp',
      class2024: 'Lớp 2024',
      nonprofitLeadership: 'Lãnh Đạo Tổ Chức Phi Lợi Nhuận',
      universityLeadership: 'Lãnh Đạo Đại Học'
    }
  };
  const t = translations[language];
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const elements = entry.target.querySelectorAll('.fade-in, .slide-in-left, .slide-in-right');
          elements.forEach((el, index) => {
            setTimeout(() => {
              el.classList.add('active');
            }, index * 100);
          });
        }
      });
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <section id="leadership" ref={sectionRef} className="w-full py-24 bg-secondary" data-id="element-831">
      <div className="container mx-auto px-4" data-id="element-832">
        <h2 className="text-3xl md:text-4xl font-display font-bold text-center mb-16 fade-in" data-id="element-833">
          {t.leadership} <span className="gradient-text" data-id="element-834">{t.experience}</span>
        </h2>
        {/* Student Government */}
        <div className="mb-20" data-id="element-835">
          <h3 className="text-2xl font-display font-bold mb-8 relative inline-block fade-in" data-id="element-836">
            {t.studentGovernment}
            <span className="absolute -bottom-2 left-0 w-full h-1 bg-gradient-to-r from-accent-cyan to-accent-violet" data-id="element-837"></span>
          </h3>
          <div className="bg-background rounded-2xl overflow-hidden card-glow slide-in-left mb-12" data-id="element-838">
            <div className="flex flex-col md:flex-row" data-id="element-839">
              <div className="w-full md:w-1/4 p-6 bg-white flex items-center justify-center" data-id="element-840">
                <img src={studentGovernment.image} alt={language === 'en' ? studentGovernment.organization : studentGovernment.organizationVi} className="max-w-full max-h-[200px] object-contain" data-id="element-841" />
              </div>
              <div className="w-full md:w-3/4 p-6" data-id="element-842">
                <div className="flex flex-col md:flex-row justify-between mb-4" data-id="element-843">
                  <div data-id="element-844">
                    <h4 className="text-xl font-display font-bold" data-id="element-845">
                      {t.classPresident}
                    </h4>
                    <p className="text-accent-cyan mb-1" data-id="element-846">
                      {t.studentGovernment} - {t.class2024}
                    </p>
                  </div>
                  <div className="text-left md:text-right mt-2 md:mt-0" data-id="element-847">
                    <p className="text-accent-amber mb-1" data-id="element-848">
                      {language === 'en' ? studentGovernment.dates : studentGovernment.datesVi}
                    </p>
                    <p className="text-muted" data-id="element-849">
                      {language === 'en' ? studentGovernment.location : studentGovernment.locationVi}
                    </p>
                  </div>
                </div>
                <ul className="space-y-2 mt-4" data-id="element-850">
                  {(language === 'en' ? studentGovernment.details : studentGovernment.detailsVi).map((detail, idx) => <li key={idx} className="flex items-start gap-2" data-id="element-851">
                      <span className="text-accent-cyan mt-1" data-id="element-852">•</span>
                      <span className="text-muted" data-id="element-853">{detail}</span>
                    </li>)}
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* Nonprofit Leadership */}
        <div className="mb-20" data-id="element-854">
          <h3 className="text-2xl font-display font-bold mb-8 relative inline-block fade-in" data-id="element-855">
            {t.nonprofitLeadership}
            <span className="absolute -bottom-2 left-0 w-full h-1 bg-gradient-to-r from-accent-cyan to-accent-violet" data-id="element-856"></span>
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-857">
            {leadershipData.nonprofit.map((item, index) => <div key={index} className={`bg-background rounded-2xl overflow-hidden card-glow tilt-card ${index === 0 ? 'slide-in-left' : 'slide-in-right'}`} style={{
            transitionDelay: `${index * 150}ms`
          }} data-id="element-858">
                <div className="h-48 overflow-hidden bg-white" data-id="element-859">
                  <img src={item.image} alt={language === 'en' ? item.organization : item.organizationVi} className="w-full h-full object-contain p-4 transition-transform duration-700 hover:scale-110" data-id="element-860" />
                </div>
                <div className="p-6" data-id="element-861">
                  <h4 className="text-xl font-display font-bold mb-1" data-id="element-862">
                    {language === 'en' ? item.organization : item.organizationVi}
                  </h4>
                  <p className="text-accent-cyan mb-3" data-id="element-863">
                    {language === 'en' ? item.role : item.roleVi}
                  </p>
                  <p className="text-muted" data-id="element-864">
                    {language === 'en' ? item.description : item.descriptionVi}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
        {/* University Leadership */}
        <div data-id="element-865">
          <h3 className="text-2xl font-display font-bold mb-8 relative inline-block fade-in" data-id="element-866">
            {t.universityLeadership}
            <span className="absolute -bottom-2 left-0 w-full h-1 bg-gradient-to-r from-accent-cyan to-accent-violet" data-id="element-867"></span>
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-868">
            {leadershipData.university.map((item, index) => <div key={index} className={`bg-background rounded-2xl overflow-hidden card-glow tilt-card ${index % 2 === 0 ? 'slide-in-left' : 'slide-in-right'}`} style={{
            transitionDelay: `${index * 150}ms`
          }} data-id="element-869">
                <div className="h-48 overflow-hidden bg-white" data-id="element-870">
                  <img src={item.image} alt={language === 'en' ? item.organization : item.organizationVi} className="w-full h-full object-contain p-4 transition-transform duration-700 hover:scale-110" data-id="element-871" />
                </div>
                <div className="p-6" data-id="element-872">
                  <h4 className="text-xl font-display font-bold mb-1" data-id="element-873">
                    {language === 'en' ? item.organization : item.organizationVi}
                  </h4>
                  <p className="text-accent-cyan mb-3" data-id="element-874">
                    {language === 'en' ? item.role : item.roleVi}
                  </p>
                  <p className="text-muted" data-id="element-875">
                    {language === 'en' ? item.description : item.descriptionVi}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};
export default Leadership;